import React, { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

// const UseDropDownPR = (url,search) => {
//     const [data, setData] = useState([]);
// const [originalData, setOriginalData] = useState([]);

//     async function getData() {
//         axiosInstance.get(url).then(res => {
//             // console.log('daataa',res.data?.data);
//             let data = res.data;
//             setOriginalData(data);
//             console.log(data,'dddd');
//             let tempData = [];
//             data.forEach((item) => {
//                 let tempObject = { value: item.id, label: item.name };
//                 tempData.push(tempObject);
//             });
//             res.data && setData(tempData);
//         }).catch(err => {
//             console.log(err, "err");
//         })
//     }
//     //     try {
//     //       const res = await axiosInstance.get(url);
//     //     } catch (error) {
//     //       console.log(error);
//     //     }
//     //   }
//     useEffect(() => {
//         getData();
//     }, [url,search]);

//     return { data,originalData,getData };
// };

// export default UseDropDownPR;



const UseDropDownPR = (url, search) => {
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const getData = async () => {
    try {
      const res = await axiosInstance.get(url);
      let newData = res.data || [];

      // Merge with selected PR if it's not in newData
      setOriginalData((prev) => {
        const merged = [...newData];
        prev.forEach((item) => {
          if (!merged.some((d) => d.id === item.id)) {
            merged.push(item);
          }
        });
        return merged;
      });

      // Convert to dropdown format
      const tempData = newData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setData(tempData);
    } catch (err) {
      console.error("Dropdown fetch error:", err);
    }
  };

  useEffect(() => {
    getData();
  }, [url, search]);

  return { data, originalData, getData };
};

export default UseDropDownPR;